import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import type { Brand, Colour, Discipline } from '../models/product.model';

@Injectable({ providedIn: 'root' })
export class TaxonomyService {
  constructor(private readonly http: HttpClient) {}

  brands(): Observable<Brand[]> {
    return this.http.get<Brand[]>(`${API_BASE_URL}/taxonomy/brands`);
  }

  disciplines(): Observable<Discipline[]> {
    return this.http.get<Discipline[]>(`${API_BASE_URL}/taxonomy/disciplines`);
  }

  colours(): Observable<Colour[]> {
    return this.http.get<Colour[]>(`${API_BASE_URL}/taxonomy/colours`);
  }
}
